import { frontendURL } from 'dashboard/helper/URLHelper';

const SidebarDashboardApp = () => import('./SidebarDashboardApp.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/dashboard-apps/:dashboardAppId'),
    component: SidebarDashboardApp,
    name: 'sidebar_dashboard_app',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
];
